module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('page-title', {
    attrs: {
      "title": "Resumo de produtos disponibilizados"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-icon"
    },
    slot: "header-icon"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.fromModuleDefinition.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "i-arrow icon-arrow-right"
  }), _vm._v(" "), _c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.toModuleDefinition.logo,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product.productId,
      staticClass: "l-col-3@md"
    }, [_c(_vm.marketplaceProvideReportProduct, {
      ref: "items",
      refInFor: true,
      tag: "component",
      attrs: {
        "product": product
      }
    })], 1)
  }), 0), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    on: {
      "click": _vm.done
    }
  }, [_vm._v(_vm._s(_vm.$t('done.label')))])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fae199ce","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProductProvide/Report.vue
// module id = 3506
// module chunks = 0